<template slot-scope>
<div>
  <div v-if="data == 'week'">
    <nav-bar title="本周峰会"></nav-bar>
    <div class="navi">
      <scroll-bar url="api/meeting/getMeetings?date=week&"></scroll-bar>
    </div>
  </div>
  <div v-if="sort == 'new'">
    <nav-bar title="最新视频"></nav-bar>
    <div class="navi">
      <scroll-bar url="api/video/getvideos?sort=new&" play="true"></scroll-bar>
    </div>
  </div>
  <div v-if="activity == 'Recommend'">
    <nav-bar title="推荐活动"></nav-bar>
    <div class="navi">
      <scroll-bar url="api/recommend/getData?" play="true"></scroll-bar>
    </div>
  </div>
  <returnPre></returnPre>
</div>
</template>

<script>
export default {
  data () {
    return {
      data: '',
      sort: '',
      type: '',
      activity: ''
    }
  },
  created () {
    console.log(this.$route)
    if (this.$route.query.data) {
      this.data = this.$route.query.data
      sessionStorage.navData = this.data
      sessionStorage.navSort = ''
      sessionStorage.navActivity = ''
    } 
    else if (this.$route.query.sort) {
      this.sort = this.$route.query.sort
      sessionStorage.navSort = this.sort
      sessionStorage.navData = ''
      sessionStorage.navActivity = ''
    } 
    else if (this.$route.query.activity) {
      this.activity = this.$route.query.activity
      sessionStorage.navActivity = this.activity
      sessionStorage.navSort = ''
      sessionStorage.navData = ''
    }
    else {
      if (sessionStorage.navData) {
        this.data = sessionStorage.navData
      } 
      else if (sessionStorage.navSort){
        this.sort = sessionStorage.navSort
      }
      else if (sessionStorage.navActivity){
        this.sort = sessionStorage.navActivity
      }
    }
    this.type = this.$route.query.type
  },
  mounted() {
    this.getShareInfo()
  }
}
</script>

<style lang="less" scoped>
  .navi {
    margin-top: 82px;
  }

</style>



// WEBPACK FOOTER //
// src/components/HomePage-Children/Navigation.vue